import { createSlice } from "@reduxjs/toolkit";


export const transactionDetailsSlice = createSlice({
  name: "transactionDetails",
  initialState : {
    data: {}
  },


  reducers: {
    setTransactionDetails: (state, { payload }) => {
      state.data = {...state.data, transactionDetails: payload }
    },
  },
});

export const { setTransactionDetails } = transactionDetailsSlice.actions;

export default transactionDetailsSlice.reducer;
